import React, { useState, useEffect } from 'react';
import { createMuiTheme, withStyles } from '@material-ui/core/styles';
import QueryLetter from '../../assets/constants/QueryLetter.Instance';
import Button from "../layout/aweLayout/Button";
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '../../components/CustomButtons/IconButton'
import PlusFileIcon from '../../components/icons/PlusFileIcon';
import PlusFillIcon from '../../components/icons/PlusFillIcon';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import mainLogo from '../../assets/images/Invent_logo_White.png';
import headerLogo from '../../assets/images/lacareheaderlogo.png';
import footerLogo from '../../assets/images/lacarefooterlogo.png';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import { connect } from 'react-redux';
import { useForm, Controller } from "react-hook-form";
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HtmlEditorComponent from "../CustomInput/HtmlEditorComponent"
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';
import Divider from '@mui/material/Divider';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import CustomAutocompleteSingle from '../CustomInput/CustomAutocompleteSingle';
import Box from '@mui/material/Box';
import pdfIcon from '../../assets/images/pdf_icon.png';
import Moment from 'moment';
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import AWS from 'aws-sdk';
import mammoth from 'mammoth';

/* AWS.config.update({
    accessKeyId:localStorage.getItem('access_key'),
    secretAccessKey: localStorage.getItem('secret_key'),
    region: process.env.REACT_APP_REGION,
});
 */
AWS.config.update({
    accessKeyId:localStorage.getItem('access_key'),
    secretAccessKey: localStorage.getItem('secret_key'),
    region: process.env.REACT_APP_REGION,
});

const styles = (theme) => ({
    dialogPaper: {
        maxWidth: '80%',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const QueryLetterCoderWorkBench = (props) => {
    const { register, formState: { errors }, handleSubmit, reset, control, getValues, setValue } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [formSubmitisLoading, setFormSubmitisLoading] = useState(false);
    //const [editorValue, setEditorValue] = useState('<p style="margin-left:0px;"><strong>Please return this provider query letter and the clinical documentation clarification by&nbsp;XXXday, Month XX, 2023,</strong> via fax (000) 000-8251 or encrypted secure email to&nbsp;<strong>providerrisk@gmail.com</strong></p><br/><p style="margin-left:0px;">&nbsp;</p><br/><p style="margin-left:0px;">If you have any questions/concerns, send an email to our risk adjustment education team at&nbsp;<span style="color:rgb(0,123,255);">providerrisk@gmail.com</span>&nbsp;or call (000) 000-8251 ex. 4000</p><br/><p style="margin-left:0px;">&nbsp;</p><br/><p style="margin-left:0px;"><u>Remember to include your best contact number</u>&nbsp;in the voicemail, email, or on the fax cover sheet.</p><br/><p style="margin-left:0px;">&nbsp;</p><br/><p style="margin-left:0px;"><u>Non-responsiveness could impact your AWE incentive.</u></p><br/><p style="margin-left:0px;"><u>﻿</u></p><br/><p style="margin-left:0px;">Thank you</p><br/><p style="margin-left:0px;">Reference Dummy HP</p><br/><p style="margin-left:0px;">Provider Risk Adjustment Education Team</p>');
    const [editorValue, setEditorValue] = useState('<p style="margin-left:0px;">Please return this provider query letter and the requested clinical documentation clarification by&nbsp;<span style="font-weight:bold;">XXXday, Month XX, 2024</span></span>, via fax (000) 000-8251 or encrypted secure email to&nbsp;<strong>providerrisk@gmail.com</strong></p><br/><p style="margin-left:0px;">If you have any questions/concerns, please send an email to our risk adjustment education team at&nbsp;<span style="color:rgb(0,123,255);">providerrisk@gmail.com</span>&nbsp;or call (000) 000-8251 ex. 4000</p><br/><p style="margin-left:0px;"><u style="font-weight:bold;">Remember to include your best contact number</u>&nbsp;in the voicemail, email, or on the fax cover sheet.</p><br/><p style="margin-left:0px;"><u style="font-weight:bold;">Non-responsiveness could impact your AWE incentive.</u></p><br><p style="margin-left:0px;">Thank you</p><p style="margin-left:0px;">Reference Dummy HP</p><p style="margin-left:0px;">Provider Risk Adjustment Education Team</p>');
    const [queryLetterEdit, setQueryLetterEdit] = useState('');
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const descriptionElementRef = React.useRef(null);
    const [attempt, setAttempt] = useState('');
    const [formattedDate, setFormattedDate] = useState('');
    const [attempOptions, setAttempOptions] = useState('');
    const [dxCodeData, setDxCodeData] = useState([]);
    const [dxCodeValue, setDxCodeValues] = useState('');
    const [isdxCodeValue, setIsDxCodeValues] = useState(false);
    const [responseEditMode, setResponseEditMode] = useState(false);
    // new

    const [headerHtml, setHeaderHtml] = useState('');
    const [footerHtml, setFooterHtml] = useState('');
    const [documentHtml, setDocumentHtml] = useState('');
    const [contentAfterThankYou, setContentAfterThankYou] = useState('');
    const [footerImageHtml, setFooterImageHtml] = useState('');
    const s3 = new AWS.S3();
    const [labels, setLabels] = useState([]);
    const [footerImage, setFooterImage] = useState('');
    const [footerContent, setFooterContent] = useState('');

    //end

    useEffect(() => {
        reset();
        console.log('QueryLetterCoderWorkBench', { props });
        setResponseEditMode(false)
        setDxCodeValues('');
        setDxCodeData([]);
        if (props.open && props.open == true) {
            var memberName = '';
            if (props?.coderBenchmarkData?.member_f_name && props?.coderBenchmarkData.member_f_name != '') {
                memberName = props?.coderBenchmarkData?.member_f_name;
                if (props?.coderBenchmarkData?.member_l_name && props?.coderBenchmarkData.member_l_name != '') {
                    memberName = props?.coderBenchmarkData?.member_f_name + ' ' + props?.coderBenchmarkData?.member_l_name;
                }
            } else if (props?.coderBenchmarkData?.member_l_name && props?.coderBenchmarkData.member_l_name != '') {
                memberName = props?.coderBenchmarkData?.member_l_name;
            }

            setValue('response_details', editorValue);
            setValue('dob', (props?.coderBenchmarkData?.member_dob && props?.coderBenchmarkData.member_dob != '') ? props?.coderBenchmarkData.member_dob : '');
            setValue('awe_id', (props?.coderBenchmarkData?.awe_id && props?.coderBenchmarkData.awe_id != '') ? props?.coderBenchmarkData.awe_id : '');
            setValue('cin', (props?.coderBenchmarkData?.ih_member_id && props?.coderBenchmarkData.ih_member_id != '') ? props?.coderBenchmarkData.ih_member_id : '');
            setValue('member_name', (memberName && memberName != '') ? memberName : '');

            if (props.querryLatterGetData && props.querryLatterGetData.length > 0 && props.querryLatterGetData[0] && props.querryLatterGetData[0]?.attempt) {
                setValue('attempt', props.querryLatterGetData[0]?.attempt + 1);
                setAttempt(props.querryLatterGetData[0]?.attempt + 1)
            } else {
                setValue('attempt', '1');
                setAttempt(1)
            }

            setValue('subject', 'Clinical Documentation Clarification');
            setValue('transaction_date', Moment().format('YYYY-MM-DD'));
            setValue('date_of_service', Moment().format('YYYY-MM-DD'));

        }
        console.log('QueryLetterCoderWorkBench', getValues());
    }, [props.open]);

    useEffect(() => {
        // Get today's date
        const today = new Date();

        // Calculate the date after 10 days
        const futureDate = new Date(today);
        futureDate.setDate(futureDate.getDate() + 10);

        // Format the future date
        const formattedDate = futureDate.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });

        // Replace the placeholder text with the formatted date
        const originalText = editorValue;
        const newText = originalText.replace('XXXday, Month XX, 2024', formattedDate);

        // Update the state with the modified text
        setEditorValue(newText);
        setFormattedDate(formattedDate)
    }, []); // Empty dependency array ensures this effect runs only once when the component mounts



    const handleResponseEditMode = () => {
        console.log('handleResponseEditMode');
        setResponseEditMode(true);
    }

    const handleInputChangeDxCode = (eventValue) => {
        setIsDxCodeValues(true);
        setDxCodeValues(eventValue);
        if (containsAlphabeticCharacters(eventValue)) {
            setValue(`action_taken_to`, eventValue);
        }
        if (eventValue.length >= 2) {

        } else {
            setDxCodeData([]);
            setIsDxCodeValues(false);
            return true;
        }
        QueryLetter.get('/get_healthcare_provider_npi_data?search=' + eventValue)
            .then(res => {
                let valuesArray = [];
                res.data.forEach((element, index) => {
                    if (!valuesArray.includes(element.icd_code + '-' + element.icd_code_description)) {
                        valuesArray.push({ 'key': element.npi, 'value': element.first_name + ' ' + element.middle_name + ' ' + element.last_name });
                    }
                });
                setDxCodeData(valuesArray);
                setIsDxCodeValues(false);
            })
            .catch(err => {
                setDxCodeData([]);
                setIsDxCodeValues(false);
            })

    }

    const handleChangeDxCode = (eventValue) => {
        // console.log(eventValue);
        setValue(`action_taken_to`, eventValue?.key);
        setDxCodeValues(eventValue?.value)
        setDxCodeData([]);
    }

    const containsAlphabeticCharacters = (text) => {
        // Regular expression to match any alphabetic character
        var regex = /[a-zA-Z]/;
        // Check if the text contains any alphabetic characters
        return regex.test(text);
    }

// new

const fetchAndProcessDocument = async () => {
    try {
        const documentBuffer = await fetchDocumentFromS3(process.env.REACT_APP_QUERY_LETTER_DOC);

        if (documentBuffer) {
            const htmlContent = await convertToHtml(documentBuffer);
            const {
                lastImage,
                headerContent,
                footerContent,
                bodyContent,
                afterThankYouContent,
                footerImage
            } = extractHeaderFooterAndContent(htmlContent);

            // setHeaderHtml(headerContent);
            setFooterHtml(footerContent);
            setFooterImage(lastImage)
            setContentAfterThankYou(afterThankYouContent);
            setFooterImageHtml(footerImage);
        }
    } catch (error) {
        console.error('Error fetching and processing document:', error);
    }
};
const fetchDocumentFromS3 = async (key) => {
    try {
        const params = {
            Bucket: process.env.REACT_APP_AWE_QUERY_LETTER_BUCKET,
            Key: key,
        };

        const data = await s3.getObject(params).promise();
        return data.Body;
    } catch (error) {
        console.error('Error fetching document from S3:', error);
        return null;
    }
};

useEffect(() => {
    fetchAndProcessDocument();
}, []);
const extractHeaderFooterAndContent = (htmlContent) => {
    // Define patterns for header, footer, and thank you content
    const headerPattern = /<h[1-6]>(.*?)<\/h[1-6]>/;
    const footerPattern = /<footer>(.*?)<\/footer>/;
    const thankYouPattern = /<p>Thank you<\/p>(.*)/s;
    const imgAfterPTagPattern = /<p[^>]*>.*?<img([^>]+)>/;
    const imgWithinPTagPattern = /<p[^>]*>.*?<img([^>]+)>.*?<\/p>/;
    const twoPTagsBeforeImgPattern = /(<p[^>]*>.*?<\/p>.*?){2}(?=<p[^>]*>.*?<img[^>]*>)/s;

    // Extract header and footer content
    const headerMatch = htmlContent.match(headerPattern);
    const footerMatch = htmlContent.match(footerPattern);
    const headerContent = headerMatch ? headerMatch[0] : '';
    const footerContent = footerMatch ? footerMatch[0] : '';

    // Remove header and footer from bodyContent
    let bodyContent = htmlContent.replace(headerPattern, '').replace(footerPattern, '');

    // Extract content after "Thank you" and replace it with new content
    const thankYouMatch = bodyContent.match(thankYouPattern);
    let afterThankYouContent = thankYouMatch ? thankYouMatch[1] : '';
    bodyContent = bodyContent.replace(thankYouPattern, '<p>Provider Risk Adjustment Education Team</p>');

    // Find and extract the footer image if present
    const imgAfterPTagMatch = afterThankYouContent.match(imgWithinPTagPattern);
    const footerImage = imgAfterPTagMatch ? `<img${imgAfterPTagMatch[1]}>` : '';
    

    if (footerImage) {
        const footerImagePattern = new RegExp(footerImage.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
        afterThankYouContent = afterThankYouContent.replace(footerImagePattern, '');
    }
    const twoPTagsBeforeImgMatch = afterThankYouContent.match(twoPTagsBeforeImgPattern);
    const twoPTagsContent = twoPTagsBeforeImgMatch ? twoPTagsBeforeImgMatch[0] : '';
    let updatedTwoPTagsContent = twoPTagsContent.replace(/Provider Risk Adjustment Education Team/gi, "");


    const imgTagPattern = /<img[^>]+>/g;

    // Extract all image tags
    const allImages = afterThankYouContent.match(imgTagPattern);

    // If there are image tags, get the last one
    const lastImage = allImages ? allImages[allImages.length - 1] : '';

    // Remove the last image tag from the content
    if (lastImage) {
        const lastImagePattern = new RegExp(lastImage.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
        afterThankYouContent = afterThankYouContent.replace(lastImagePattern, '');
    }

    // Fetch values from <p> tags and set labels
    const result = fetchValuesFromP(bodyContent);
    setLabels(result.keysArray);
    // Define a pattern to match all <p> tags
    const pTagPattern = /<p[^>]*>(.*?)<\/p>/g;

    // Find all matches
    const pTags = [...afterThankYouContent.matchAll(pTagPattern)];

    // Extract the last <p> tag's content
    const lastPTagContent = pTags.length ? pTags[pTags.length - 1][1] : '';

    setFooterContent(lastPTagContent);


    return {
        updatedTwoPTagsContent,
        lastImage,
        headerContent,
        footerContent,
        bodyContent,
        afterThankYouContent,
        footerImage
    };

};

function fetchValuesFromP(bodyContent) {
    // Remove <img> tags first
    const noImgContent = bodyContent.replace(/<img[^>]*>/g, '');

    // Regex to extract <p> tags
    const pTagPattern = /<p[^>]*>(.*?)<\/p>/g;
    const strongTagPattern = /<strong>(.*?)<\/strong>/g;

    let match;
    const keysArray = []; // To store values before ":" or "-"
    const valuesArray = []; // To store values after ":" or "-"

    // Loop through all <p> tags
    while ((match = pTagPattern.exec(noImgContent)) !== null) {
        let pTagContent = match[1]; // Content inside <p> tag

        // Check if <strong> tag is present
        if (strongTagPattern.test(pTagContent)) {
            // Remove <strong> tag but keep its content
            pTagContent = pTagContent.replace(strongTagPattern, '$1');
        }

        // Split by ":" or "-" and check for key-value structure
        const splitByColon = pTagContent.split(':');
        const splitByDash = pTagContent.split('-');

        if (splitByColon.length === 2) {
            const key = splitByColon[0].trim();
            const value = splitByColon[1].trim();
            if (key) keysArray.push(key); // Store key (before ":")
            if (value) valuesArray.push(value); // Store value (after ":") if not blank
        }
        const key = splitByColon[0].trim().toLowerCase();
        const value = splitByColon.slice(1).join(':').trim();

        if ('detail'.includes(key) || 'details'.includes(key)) {
            // Create a temporary element to extract content before <img> tag
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = value;

            const imgTag = tempDiv.querySelector('img');
            const contentBeforeImg = imgTag ? value.split(imgTag.outerHTML)[0] : value;

            // Store the content in setEditorValue
            setEditorValue(contentBeforeImg.trim());

            setValue('response_details', contentBeforeImg.trim());
        }

    }

    // Return the results
    return { keysArray, valuesArray };
}



const convertToHtml = async (arrayBuffer) => {
    try {
        const result = await mammoth.convertToHtml({ arrayBuffer });
        return result.value;
    } catch (error) {
        console.error('Error converting document:', error);
        return '';
    }
};

// end

    const onSubmit = (data) => {
        setFormSubmitisLoading(true);
        let controlUser = JSON.parse(localStorage.getItem('controlUser'));
        data.created_by = controlUser?.email;
        data.created_on = Moment().format('YYYY-MM-DD HH:mm:ss');
        data.cw_id = getValues('cin');
        data.cin = getValues('cin');
        data.updated_by = controlUser?.email;
        data.temp_id = "1";
        data.lob = props?.lobSelect.toString();
        data.year = props?.yearSelect.toString();
        data.action_taken_to = data.action_taken_to.toString();
        data.attempt = data.attempt.toString();
        data.delivery_method = data['dob'].toString();
        delete data['member_name'];
        delete data['dob'];
        console.log({ data });
        QueryLetter.post('/add_query_letter', data)
            .then(res => {
                toast.success('Query letter has been added successfully.');
                props.handleClose();
                setFormSubmitisLoading(false);
            })
            .catch(err => {
                setFormSubmitisLoading(false);
                toast.error(err?.response?.data?.message);
            })
    }


    const handleChangeEditor = (event) => {
        setValue('response_details', event);
        setEditorValue(event);
    }
    const fields = ['attempt', 'transaction_date', 'subject', 'member_name', 'dob', 'date_of_service', 'awe_id', 'action_taken_to', 'clarification_description', 'response_details'];

    const renderField = (label, fieldName, index) => {
        return (
            <div className="row mb-2" key={index}>
                <div className="col-lg-3 align-items-center">
                    <div className='mb-1'>
                        <strong style={{ fontSize: "14px" }}>{label}:</strong>
                    </div>
                </div>
                <div className="col-lg-6 align-items-center">
                    <Controller
                        name={fieldName}
                        control={control}
                        render={({ field }) => {
                            // Conditionally render different input types based on field names
                            if (fieldName === 'attempt') {
                                return (
                                    <select {...field} className="form-control" disabled={true}>
                                        <option value={''}>Select Attempt</option>
                                        {attempOptions}
                                    </select>
                                );
                            } else if (fieldName === 'transaction_date') {
                                return <input
                                    {...field}
                                    type="date"
                                    autoComplete="off"
                                    className="form-control" 
                                    readOnly={true}
                                />;
                            } else if (fieldName === 'subject') {
                                return <input
                                    {...field}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control"
                                />;
                            } else if (fieldName === 'member_name') {
                                return <input
                                    {...field}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control"
                                    placeholder="Member Name"
                                    readOnly={true}
                                />
                            } else if (fieldName === 'dob') {
                                return <input
                                    {...field}
                                    type="date"
                                    autoComplete="off"
                                    className="form-control"
                                    readOnly={true}
                                />
                            } else if (fieldName === 'date_of_service') {
                                return <input
                                    {...field}
                                    type="date"
                                    autoComplete="off"
                                    className="form-control"
                                    max={Moment().format("YYYY-MM-DD")}
                                />
                            } else if (fieldName === 'awe_id') {
                                return <input
                                    {...field}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control"
                                    readOnly={true}
                                />
                            } else if (fieldName === 'action_taken_to') {
                                return <input
                                    {...field}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control"
                                    placeholder="Enter Provider Name"
                                />
                            } else if (fieldName === 'clarification_description') {
                                return <textarea
                                    {...field}
                                    rows="3"
                                    autoComplete="off"
                                    className="form-control"
                                    placeholder="Enter Clarification Description"
                                />
                            } else if (fieldName === 'response_details') {
                                return (
                                    <HtmlEditorComponent
                                      {...field}
                                      onChange={handleChangeEditor}
                                      style={{ height: '300px', width: '1200px' }} // Adjust width as needed
                                    />
                                  );
                                  
                            } else {
                                return <input {...field} type="text" autoComplete="off" className="form-control" placeholder={label} />;
                            }
                        }}
                        rules={{ required: true }}
                    />
                    {errors && errors?.[fieldName]?.type === "required" && (
                        <label className="form-input-error">This field is required</label>
                    )}
                </div>
            </div>
        );
    }; 
    useEffect(() => {
        setAttempOptions('');
        var attempOptiosTemp = [];
        for (let i = 1; i <= (attempt + 1); i++) {
            attempOptiosTemp.push(
                <option value={i} >
                    {getOrdinalSuffix(i)} Attempt
                </option>
            );
        }
        setAttempOptions(attempOptiosTemp)
    }, [attempt]);
    const getOrdinalSuffix = (number) => {
        const suffixes = ["th", "st", "nd", "rd"];
        const lastDigit = number % 10;
        const suffix = lastDigit <= 3 ? suffixes[lastDigit] : suffixes[0];
        return number + suffix;
    }
    const increasedSizeImg = footerImage.replace(/<img([^>]+)>/, (match, p1) => {
        return `<img ${p1} style="width: 100%; height: auto; display: block; margin-left: auto; margin-right: 0;">`;
    });

    return (
        <>
            <div style={{ display: "inline-block" }}>
                <IconButton className='mr-2' onClick={() => props.handleClickOpen()}>
                    <PlusFillIcon className="w16" />
                </IconButton>
            </div>

            <MuiDialog
                open={props.open}
                onClose={props.handleClose}
                fullWidth={true}
                maxWidth={'md'}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >

                <DialogTitle id="scroll-dialog-title">
                    <div className='row'>
                        <div className="col-lg-4 text-left">
                            <span style={{ color: "red" }}>
                                {getOrdinalSuffix(attempt)} Attempt
                            </span>
                        </div>
                        <div className="col-lg-4 text-center" style={{ fontSize: "20px" }}>
                            <strong>
                                Provide Query Letter
                            </strong>
                        </div>
                        <div className="col-lg-4 text-right">
                        <span className='p-1' style={{ fontSize: "25px" }}>
                        <div className="after-thank-you" dangerouslySetInnerHTML={{ __html: footerImageHtml }} />
                            </span>
                        </div>
                    </div>
                </DialogTitle>
                <Divider className="mr-3 ml-3" style={{ backgroundColor: "#1a9698" }} />
                <MuiDialogContent dividers={'paper'} className='custom-scrollbar'>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                    >
                        <form id="queryForm">
                            {isLoading && isLoading == true ?
                                <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                    <CircularProgress />
                                </div>
                                :
                                <></>
                            }
                            <div>
                                {labels.map((label, index) => {
                                    // If index is within the fields array length, render the mapped field, otherwise render a default text field
                                    return renderField(label, fields[index] || `field_${index}`, index);
                                })}
                            </div>

                            <br /><br /><br />


                            <div className="footer footer-pdf d-flex justify-content-between pt-3 border-top border-primary">
                                <div className="col-md-9 text-left">
                                <div className="address text-muted" dangerouslySetInnerHTML={{ __html: footerContent }} />

                                </div>
                                <div className="col-md-3 text-right">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: increasedSizeImg }}
                                        className="logo"
                                    />
                                </div>
                            </div>

                        </form>
                    </DialogContentText>
                </MuiDialogContent>
                <Divider className="mr-3 ml-3" style={{ backgroundColor: "#1a9698" }} />
                <DialogActions>

                    <div className="form-group flex_item_cs gap10">
                        <Button type='button' className={"btn-white minw80"} onClick={props.handleClose}>CANCEL</Button>
                        <Button form="queryForm" type='submit' className={"minw80"} onClick={handleSubmit(onSubmit)} disabled={isLoading && isLoading == true ? true : false}>SAVE</Button>
                    </div>
                </DialogActions>
            </MuiDialog >
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        userDetails: state.auth.userDetails,
        yearSelect: state.moduleFilter.yearSelect,
        providerGroupSelect: state.moduleFilter.providerGroupSelect,
        lobSelect: state.moduleFilter.lobSelect,
    };
}
export default (withStyles(styles), connect(mapStateToProps))(QueryLetterCoderWorkBench);
